<template>
    <basic-dialog
        class="goods-sel-dlg"
        :title="title"
        width="80%"
        :visible="visible"
        :handle-close="handleClose"
        :handle-closed="handleClosed"
        :handle-ok="handleOk"
        :close-text="$t('language.5o6uut7rgac0')">
        <el-form class="search-form" size="small" label-width="80px" :model="query">
            <div class="col-l">
                <el-row>
                    <el-col :span="8">
                        <el-form-item :label="$t('language.5o6trh9vltc0')">
                            <el-input v-model.trim="query.userName" :maxlength="30" clearable/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :title="$t('language.5o6trh9vmg00')" :label="$t('language.5o6trh9vmg00')">
                            <el-input v-model.trim="query.userCode" :maxlength="30" clearable/>
                        </el-form-item>
                    </el-col>
                     <el-col :span="8">
                        <el-form-item :title="$t('language.5o6trh9vmiw0')" :label="$t('language.5o6trh9vmiw0')">
                            <el-input v-model.trim="query.userAlias" :maxlength="30" clearable/>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
            <div class="col-r">
                <el-button type="primary" size="small" @click="handleSearch">{{$t('language.5o6trh9vn600')}}</el-button>
                <el-button size="small" @click="handleReset">{{$t('language.5o6trh9vn900')}}</el-button>
            </div>
        </el-form>
        <basic-list
            ref="basicList"
            select-type="multiple"
            :show-select-col="true"
            :show-action-col="false"
            :show-index-col="false"
            :fields="fields"
            :setClmnsFlg="false"
            :list="list"
            :loading="loading"
            :total="total"
            :page-index="pageIndex"
            :page-size="pageSize"
            :page-index-change="pageIndexChange"
            :page-size-change="pageSizeChange"
            :selection-change="selectionChange"/>
    </basic-dialog>
</template>

<script>
import BasicDialog from '@/components/basicDialog'
import BasicList from '@/components/basicList'
import { mapActions } from 'vuex'
import { log } from 'util'

const DEFAULTS = {
    query: {
        userName: undefined,
        userCode: undefined,
        userAlias: undefined,
    },
    loading: false,
    total: 0,
    pageIndex: 0,
    pageSize: 10,
    list: [],
    selRows: []
}

export default {
    components: {
        BasicDialog,
        BasicList
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        updateVis: {
            type: Function,
            default: () => {}
        },
        selectRole: Object,
        title: {
            type: String,
            default: ""
        },
        tenementCode: [ String, Number ]
    },
    data () {
        return {
            ..._.cloneDeep(DEFAULTS),
            fields: [
                { key: 'userName', name: `${this.$t('language.5o6trh9vltc0')}` },
                { key: 'userCode', name: `${this.$t('language.5o6trh9vmg00')}` },
                { key: 'userAlias', name: `${this.$t('language.5o6trh9vmiw0')}` },
                {
                    key: 'userSystemType', name: `${this.$t('language.5o6trh9vmxg0')}`, formatter: function (row, column, cellValue, index) {
                        return _params.users.userSystemType[cellValue]
                    }
                },
            ],
        }
    },
    watch: {
        visible (newVal) {
            if (newVal) {
                this.query = { ...DEFAULTS.query }
                this.pageIndex = 0
                this.queryList()
            }
        }
    },
    methods: {
        handleClose () {
            this.updateVis(false)
        },
        handleClosed () {
            const defaults = _.cloneDeep(_.get(DEFAULTS, ['selRows', 'query']))
            for (let key in defaults) {
                this[key] = defaults[key]
            }
            this.$refs.basicList.resetData()
        },
        handleOk () {
            // console.log("选择的角色", this.selectRole)
            // 选择的角色 this.selectRole  分配用户 this.selRows

            // if (!this.selRows.length) {
            //     this.$message.error('请选择用户')
            //     return
            // }
            const params = this.toEnd()
            this.handleSave(params)
            // this.queryList()
            // this.updateVis(false)
        },
        pageIndexChange (index) {
            this.pageIndex = index - 1
            this.queryList()
        },
        pageSizeChange (size) {
            this.pageIndex = 0
            this.pageSize = size
            this.queryList()
        },
        selectionChange (rows) {
            this.selRows = rows
        },
        handleSearch () {
            this.pageIndex = DEFAULTS.pageIndex
            this.queryList()
        },
        handleReset () {
            this.query = _.cloneDeep(DEFAULTS.query)
            this.pageIndex = DEFAULTS.pageIndex
            this.queryList()
        },
        queryList () {
            const query = _.cloneDeep(this.query)
            query.dataRoleId = this.selectRole.id
            jt.object.removeEmptyAttr(query)
            api.dataRole.queryUserList({
                data: { ...query, tenementCode: this.$store.state.app.tenementInfoObj.tenementCode },
                page: {
                    pageIndex: this.pageIndex + 1,
                    pageSize: this.pageSize
                }
            }).then( ({code, data}) => {
                if (code === 200) {
                    this.list = data.rows || []
                    this.total = data.rowTotal || 0
                    this.$nextTick(() => {
                        let arr = this.list.filter( item => item.tenementId )
                        arr.forEach( item => {
                            this.$refs.basicList.$refs.table.toggleRowSelection(item, true)
                        } )
                    })
                }
                // this.$refs.basicList.resetData('radioIndex')
            } )
        },
        toEnd () {
            // 选择的角色 this.selectRole  分配用户 this.selRows
            let { id } = this.selectRole || {}
            const userIds = []
            this.selRows.forEach( item => { userIds.push(item.id) } )
            const allUserIds = []
            this.list.forEach( item => { allUserIds.push(item.id) } )
            const params = { id, userIds, allUserIds, tenementCode: this.tenementCode }
            return params
        },
        // 分配数据角色
        handleSave () {
            const params = this.toEnd()
            api.dataRole.assignUserForDataRoles(params).then( ({ code, msg }) => {
                if (code === 200) {
                    this.$message.success(msg)
                    this.queryList()
                } else {
                    this.$message.error(msg)
                }
            } )
        }
    }
}
</script>

<style lang="scss" scoped>
.search-form {
    display: flex;
    .col-l {
        flex: 1;
        display: flex;
        .el-row {
            flex: 1;
            display: flex;
            flex-wrap:wrap;
            margin-right: 20px;
        }
    }
    .col-r {
        width: 140px;
    }
}
.basic-list {
    padding-top: 0;
}
</style>


